











import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class IdrPatientDetailTimeTab extends Vue {
  @Prop()
  private contents: any;
  @Prop()
  private cContent: any;
  /**
   * @description 改变当前选择内容
   */
  private changeCurrentContent(c) {
    this.$emit("change", c);
  }
}
